export enum LogoType {
    MEDIFIT = 'MEDIFIT',
    HELLODOC = 'HELLODOC',
}
